module.exports = __webpack_public_path__ + "static/img/partner-logo7.c0e7566d.jpg";